import React from 'react';
import withReduxContainer, { OwnProps } from './Zone.container';
import { withSectionContext } from '../../Sections/SectionContext';

import Zone, { Props as ImportedProps } from './Zone';
export type Props = ImportedProps;
export { default as ZoneGroup } from './ZoneGroup';
export default withSectionContext(
  withReduxContainer(Zone) as React.ComponentType<OwnProps>
);
